import { createApp } from 'vue'

import App from './App.vue'
import router from './router';
import '@/assets/scss/app.scss'
import VueFeather from 'vue-feather';
import store from './store'
import Breadcrumbs from './components/bread_crumbs';
import VueApexCharts from "vue3-apexcharts";
import "bootstrap"
import settingPage from "./components/settingPage.vue" 
import DropZone from "dropzone-vue";
import 'bootstrap/dist/js/bootstrap.bundle'
import Vue3EasyDataTable from 'vue3-easy-data-table';
import 'vue3-easy-data-table/dist/style.css';
import PerfectScrollbar from 'vue3-perfect-scrollbar'
import 'vue3-perfect-scrollbar/dist/vue3-perfect-scrollbar.css'
import Toaster from "@meforma/vue-toaster";
import Vue3Tour from 'vue3-tour'
import 'vue3-tour/dist/vue3-tour.css'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import bcard from "./components/b-card.vue" 
import Vue3Toasity from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import VueAnimateOnScroll from 'vue3-animate-onscroll';
import { quillEditor } from "vue3-quill";
import Lightbox from 'vue-easy-lightbox'
import { VueMasonryPlugin } from 'vue-masonry';
import vue3StarRatings from "vue3-star-ratings";
import Datepicker from 'vue3-datepicker'
import VueNumber from "vue-number-animation";  
import SimpleTypeahead from 'vue3-simple-typeahead';
import 'vue3-simple-typeahead/dist/vue3-simple-typeahead.css';
import Multiselect from 'vue-multiselect'
import "vue-multiselect/dist/vue-multiselect.css"
import { createI18n } from 'vue-i18n';
import { defaultLocale, localeOptions } from './constants/config';

import Toast from 'vue-toastification';
import "vue-toastification/dist/index.css";
import "../src/utils/buttons.css";

//Dashboard screens --> Laugfs SFA Web Portal pages
import  '@/pages/complaint/complaintManagement.vue';
import '@/pages/orders/orderManagement.vue';
import '@/pages/stock/dispatch/distpatch.vue';
import '@/pages/stock/gate_pass/getPass.vue';
import '@/pages/stock/gate_pass_in/getPassIn.vue';
import '@/pages/stock/stock_allocation/stockAllocation.vue';
import '@/pages/stock/stock_allocation/newStockAllocation.vue';
import '@/pages/stock/dispatch/newDistpatch.vue';
import  '../src/pages/report/sales/salesReport.vue';
import './pages/invoice/viewInvoice/invoice.vue';
import '@/pages/stock/order_request/orderRequest.vue';
import '@/pages/stock/grn/grn.vue';
import '@/pages/report/invoice_summery/invoiceSummery.vue';
import '@/pages/stock/order_request/editOrderRequest.vue';
import '@/pages/stock/order_request_schedule/poshedule.vue';
import '@/pages/stock/order_request_schedule/posheduleEdit.vue';
import '@/pages/stock/order_request_schedule/posheduleEditForm.vue';

import '@/pages/report/direct_loss_sale/directLossSale.vue';


//Screens --> Laugfs SFA Web Portal
import '@/pages/stock/stock_allocation/editeStockAlloction.vue';


//Modals --> Laugfs SFA Web Portal
import '../src/pages/Modal/viewComplaint.vue';
import  '../src/pages/Modal/editModal.vue';
import '../src/pages/Modal/editStockAllocation.vue';
import  '../src/pages/Modal/dealerVisitDetails.vue';

// Font Awesome
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faFlag, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons';

library.add(faFlag, faEdit, faTrash);


const app = createApp(App);
app.component('font-awesome-icon', FontAwesomeIcon);

//API services--> Laugfs SFA Web Portal
import '../src/services/axiosInstance';
import '../src/services/apiConfig';
import '../src/services/authService';
import '../src/services/dataService';
import  '../src/services/versionService'// to manage version of the application

 const locale = (localStorage.getItem('currentLanguage') && localeOptions.filter(x => x.id === localStorage.getItem('currentLanguage')).length > 0) ? localStorage.getItem('currentLanguage') : defaultLocale;
 const i18n = createI18n({
 
  locale: locale,

 });
createApp(App).use(Toast).use(i18n).use(SimpleTypeahead).use(VueMasonryPlugin).use(VueNumber).component("vue3-star-ratings", vue3StarRatings).use(quillEditor).use(Lightbox).use(store).use(VueSweetalert2).use(VueAnimateOnScroll).use(Vue3Toasity).use(Vue3Tour).use(Toaster).use(router).component("settingPage", settingPage).component("b-card", bcard).use(PerfectScrollbar).use(DropZone).component('multiselect', Multiselect).component(VueFeather.name, VueFeather).component('Breadcrumbs', Breadcrumbs).component("apexchart", VueApexCharts).component('EasyDataTable', Vue3EasyDataTable).use(require('vue-chartist')).component('Datepicker', Datepicker).mount('#app')

